import * as React from 'react';
import { SVGProps } from 'react';

const IconContourSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#SvgIconContour_size_s__a)">
      <path
        d="M3 2.079a.7.7 0 0 1 1.015-.625L12.45 5.7a1 1 0 0 1 .55.893v6.752a.7.7 0 0 1-1.015.626L3.55 9.724A1 1 0 0 1 3 8.831V2.079Z"
        fill="#CCD9E0"
      />
      <path
        d="M3 4.094V3.03c.316-.007.699-.003 1.134.027 1.046.073 2.338.176 3.807.714.039.106.059.22.059.337v.794c-1.34-.495-2.552-.644-3.532-.713-.208-.014-.404-.032-.584-.05-.352-.032-.648-.06-.877-.045H3Z"
        fill="var(--color-bg-warning)"
      />
    </g>
    <g clipPath="url(#SvgIconContour_size_s__b)">
      <path
        d="M15 2.853a.7.7 0 0 0-.848-.684L1.788 4.85A1 1 0 0 0 1 5.826v6.83a.7.7 0 0 0 .848.684l12.364-2.68A1 1 0 0 0 15 9.684v-6.83Z"
        fill="var(--color-bg-ghost)"
      />
      <path
        d="M15 2.853a.7.7 0 0 0-.848-.684L1.788 4.85A1 1 0 0 0 1 5.826v6.83a.7.7 0 0 0 .848.684l12.364-2.68A1 1 0 0 0 15 9.684v-6.83Z"
        fill="#EBEEEF"
      />
      <path
        d="M1 7.522c.126-.094.284-.211.518-.374.467-.327 1.137-.77 1.955-1.246C5.107 4.954 7.348 3.87 9.75 3.36c2.405-.51 3.826-.204 4.66.295.248.148.441.311.59.47V6.27c0-.227-.258-.742-.477-.997-.095-.146-.37-.413-.683-.6-.624-.373-1.828-.69-4.09-.208-2.264.48-4.398 1.509-5.973 2.423-.786.457-1.428.882-1.873 1.193-.314.22-.688.505-.904.71V7.522Z"
        fill="var(--color-bg-warning)"
      />
      <path
        d="M6.25 6.71C1.583 7.702 1 10.142 1 10.142v1.544c1.75-1.015 4.083-2.798 8.167-3.666 2.916-.62 4.86.254 5.833.69V7.168s-4.083-1.449-8.75-.457Z"
        fill="var(--color-bg-normal)"
      />
      <path
        d="M15 9.106a10.162 10.162 0 0 0-.447-.01c-.361-.002-.889.005-1.566.044-1.354.079-3.304.285-5.701.794-2.398.51-4.057 1.071-5.126 1.511-.521.214-.902.4-1.16.537v.674c0 .17.06.324.159.444a12.093 12.093 0 0 1 1.168-.548c1.007-.414 2.61-.96 4.959-1.459 2.348-.499 4.254-.7 5.57-.776a23.522 23.522 0 0 1 1.512-.042c.14 0 .284.006.38.01l.049.002.028-.039c.094-.174.125-.301.173-.548L15 9.69v-.584Z"
        fill="var(--color-bg-alert)"
      />
    </g>
    <g clipPath="url(#SvgIconContour_size_s__c)">
      <path
        d="M3 2.135a.7.7 0 0 1 1.014-.626l8.435 4.234a1 1 0 0 1 .551.894v6.753a.7.7 0 0 1-1.014.625L3.551 9.781A1 1 0 0 1 3 8.887V2.135Z"
        fill="#CCD9E0"
      />
      <path
        d="M8 4.938V3.833a10.8 10.8 0 0 1 1 .433c1.92.946 3.177 2.255 3.847 3.207.055.077.105.152.153.226v1.412a12.854 12.854 0 0 0-.745-1.222c-.476-.675-1.457-1.637-3.204-2.499A11.036 11.036 0 0 0 8 4.938Z"
        fill="var(--color-bg-warning)"
      />
      <path
        d="M8 8.298V6.44c2.817 1.943 5 4.585 5 4.585v1.416c-.764-.967-2.326-2.83-4.618-3.96A16.95 16.95 0 0 0 8 8.298Z"
        fill="var(--color-bg-normal)"
      />
      <path
        d="M8 10.956V9.79a25.49 25.49 0 0 1 3.433 2.256l.399.313 1.168.917v.13c0 .317-.091.528-.285.649-.053-.04-.16-.141-.232-.195a7.79 7.79 0 0 1-.31-.247 9.578 9.578 0 0 0-.813-.617A40.937 40.937 0 0 0 8 10.956Z"
        fill="var(--color-bg-alert)"
      />
    </g>
    <defs>
      <clipPath id="SvgIconContour_size_s__a">
        <path
          d="M3 2c0-.552.402-.802.897-.558L8 3.466V12L3.897 9.977C3.402 9.732 3 9.087 3 8.534V2Z"
          fill="#fff"
        />
      </clipPath>
      <clipPath id="SvgIconContour_size_s__b">
        <path
          fill="#fff"
          transform="matrix(.97815 -.20791 0 1 1 5.009)"
          d="M0 0h14.313v8.453H0z"
        />
      </clipPath>
      <clipPath id="SvgIconContour_size_s__c">
        <path
          d="m8 3.508 4.103 2.024c.495.244.897.89.897 1.442v6.492c0 .552-.402.802-.897.558L8 12V3.508Z"
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
);
export default IconContourSizeS;
